import { render, staticRenderFns } from "./dine-card.vue?vue&type=template&id=0222028c&scoped=true"
import script from "./dine-card.vue?vue&type=script&lang=js"
export * from "./dine-card.vue?vue&type=script&lang=js"
import style0 from "./dine-card.vue?vue&type=style&index=0&id=0222028c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222028c",
  null
  
)

export default component.exports